<template>
  <div id="deeplink" class="describe" :class="{lan_En: lan != 'zh'}">
    <div class="desc_title">{{ $t('home.desc.title') }}</div>
    <div class="desc_left">
      <div class="left_title">{{ $t('home.desc.left.text') }}</div>
      <div class="left_text">{{ $t('home.desc.left.text1') }}</div>
      <div class="left_text">{{ $t('home.desc.left.text2') }}</div>
      <!-- <div class="left_intro_content">
        <div class="left_intro">
            <p class="left_intro_title">5</p>
            <p class="left_intro_text">Phase 5</p>
          </div>
          <div class="left_intro">
            <p class="left_intro_title">10000</p>
            <p class="left_intro_text">Weekly $10,000 Prize Pool Drawing</p>
          </div>
      </div> -->
      <!-- <div class="left_intro">
        <a href="https://blocksafu.com/audit/0xD610Be30b06A3828A27D608a38F1E85faAFdEDcC" target="_blank" rel="noopener noreferrer" class="left_intro_text">{{ $t('home.desc.left.text3') }}</a>
        <div class="left_intro_img"></div>
      </div> -->
      <div class="left_btns">
        <a class="left_btn" href="https://www.deeplink.cloud/DeepLink_Protocol.pdf" target="_blank">
          <div class="left_btn_icon"><img src="../assets/desc/icon1.png" alt=""></div> <p>{{ $t('home.desc.left.btn1') }}</p>
        </a>
        <!-- <div class="left_btn" @click="window.open()">
          <div class="left_btn_icon"><img src="../assets/desc/icon1.png" alt=""></div> <p>{{ $t('home.desc.left.btn1') }}</p>
        </div> -->
        <a class="left_btn" href="https://www.deeplink.cloud/software" target="_blank">
          <div class="left_btn_icon"><img src="../assets/desc/icon2.png" alt=""></div> <p>{{ $t('home.desc.left.btn2') }}</p>
        </a>
        <!-- <div class="left_btn" @click="window.open('https://www.deeplink.cloud/')">
          <div class="left_btn_icon"><img src="../assets/desc/icon2.png" alt=""></div> <p>{{ $t('home.desc.left.btn2') }}</p>
        </div> -->
      </div>
      <div class="left_video">
        <iframe width="100%" height="100%" src="https://www.youtube.com/embed/T86MBoTeRB8?si=tvSr5mwpf_cHM20_" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        <!-- <video src="https://www.deeplink.cloud/DeepLink_Video.mp4" poster="../assets/desc/video_bg.png" loop controls controlslist="noplaybackrate, nopip" ></video> -->
      </div>
    </div>
    <div class="desc_right">
      <!-- <div class="right_title">{{ $t('home.desc.right.text1_1') }}</div> -->
      <div class="right_text">{{ $t('home.desc.right.text2', {price: dlc_price, days: countDown.days, hour: countDown.hours, min: countDown.mins}) }}</div>
      <!-- <div class="right_desc">{{ $t('home.desc.right.text3', {pre_num: pre_num}) }}</div> -->
      <!-- <div class="right_desc">{{ $t('home.desc.right.text4', {pre_num1: pre_num1}) }}</div> -->
      <!-- <div class="right_desc">{{ $t('home.desc.right.text5') }}</div>
      <div class="right_desc">{{ $t('home.desc.right.text6') }}</div> -->
      <!-- <div class="right_desc">{{ $t('home.desc.right.text7') }}</div> -->
      <!-- <div class="right_desc">{{ $t('home.desc.right.text1_2', {pre_num1: pre_num1})}}</div> -->
      <!-- <div class="width100">
        <div class="right_pro">
          <div class="progress" :style="{width: process + '%'}">{{ process > 50 ? $t('home.desc.right.process', {process: process}) : process + '%' }}</div>
        </div>
        <div class="right_text1">70,000,000 DLC</div>
      </div> -->
      <div class="width100">
        <div class="right_btn1 notClick"><div class="btn1_icon"><img src="../assets/desc/icon3.png" alt=""></div> <p>{{ (userinfo && userinfo.email && userinfo.status == 1) ? $t('home.desc.right.btn1_1') : $t('home.desc.right.btn1') }}</p></div>
        <!-- <div class="right_text1" v-if="userinfo && userinfo.email && userinfo.status == 0">{{ $t('home.desc.right.text7_1') }}</div>
        <div class="right_text1" v-else-if="userinfo && userinfo.email && userinfo.status == 1">{{ $t('home.desc.right.text7_2') }}</div>
        <div class="right_text1"v-else-if="userinfo && userinfo.email && userinfo.status == 2">{{ $t('home.desc.right.text7_3') }}</div>
        <div class="right_text1"v-else>{{ $t('home.desc.right.text7_4') }}</div> -->
      </div>
      <div class="width100">
        <div class="right_btn1 notClick"><div class="btn1_icon"><img src="../assets/desc/icon4.png" alt=""></div> <p>{{ $t('home.desc.right.btn2') }}</p></div>
        <!-- <div class="right_btn1" @click="BuyDLCToken"><div class="btn1_icon"><img src="../assets/desc/icon4.png" alt=""></div> <p>{{ $t('home.desc.right.btn2')}}</p></div> -->
      </div>
      <!-- <div v-if="inviteInfo.userLevel == 1" class="right_btn2" @click="CopyLink">{{ $t('home.desc.right.btn3_1') }}</div>
      <div v-else-if="inviteInfo.userLevel == 2" class="right_btn2" @click="CopyLink">{{ $t('home.desc.right.btn3_2') }}</div>
      <div v-else-if="inviteInfo.userLevel == 3" class="right_btn2" @click="CopyLink">{{ $t('home.desc.right.btn3_3') }}</div> -->
      <div class="right_btn2">{{ $t('home.desc.right.btn3') }}</div>
      <div class="right_community">
        <a href="https://twitter.com/DeepLinkGlobal" target="_blank"><img src="../assets/desc/tw.png" alt=""></a>
        <a href="https://t.me/deeplinkglobal" target="_blank"><img src="../assets/desc/tg.png" alt=""></a>
        <a href="https://youtube.com/@deeplinkglobal" target="_blank"><img style="width: 30px; height: 30px;" src="../assets//desc/ytb.png" alt=""></a>
      </div>
      <div class="right_text2">{{ $t('home.desc.right.text8') }}</div>
    </div>
  </div>
  <Teleport to="body">
    <el-dialog v-model="dialogVisible" align-center title="Tips" :width="(screenWidth < 1200 ? '90%' : 1000)" :show-close="false" draggable>
      <template #header="{ close, titleId, titleClass }">
        <div class="dialog-header">
          <div :id="titleId">{{ $t('dialog1.title') }}</div>
          <div @click="close" class="icon"></div>
        </div>
      </template>
      <div class="dialog-content desc_dialog">
        <div class="upload_img">
          <div class="upload_content">
            <div class="upload_title">{{ $t('dialog1.text1') }}</div>
            <div class="upload_cont upload_cont1" @click="uploadImg1">
              <div v-show="Form_KYC_Value.imageUrl1" class="seeImage"><img :src="Form_KYC_Value.imageUrl1" alt=""></div>
              <input ref="fileInput1" type="file" @change="handleFileUpload1" style="display: none;">
              <div v-show="!Form_KYC_Value.imageUrl1" class="upload_icon"><img src="../assets/pic1.png" alt=""></div>
              <div v-show="!Form_KYC_Value.imageUrl1" class="upload_tip">{{ $t('dialog1.text3') }}</div>
            </div>
            <div class="upload_tips">{{ $t('dialog1.error16') }}</div>
          </div>
          <div class="upload_content">
            <div class="upload_title">{{ $t('dialog1.text2') }}</div>
            <div class="upload_cont upload_cont2">
              <div class="upload_cont" @click="uploadImg2">
                <div v-show="Form_KYC_Value.imageUrl2" class="seeImage"><img :src="Form_KYC_Value.imageUrl2" alt=""></div>
                <input ref="fileInput2" type="file" @change="handleFileUpload2" style="display: none;">
                <div v-show="!Form_KYC_Value.imageUrl2" class="upload_icon"><img src="../assets/pic2.png" alt=""></div>
                <div v-show="!Form_KYC_Value.imageUrl2" class="upload_tip">{{ $t('dialog1.text4') }}</div>
              </div>
            </div>
            <div class="upload_tips">{{ $t('dialog1.error16') }}</div>
          </div>
        </div>
        <div class="upload_content_tips">{{ $t('dialog1.tip1') }}</div>
        <div class="dialog-input">
          <p class="input_label">{{ $t('dialog1.text6') }}</p>
          <p class="input_title width400">{{ Form_KYC_Value.wallet }}</p>
          <p class="input_tips">{{ $t('dialog1.text7_1') }}</p>
        </div>
        <!-- <div class="dialog-input">
          <p class="input_label">{{ $t('dialog1.text5') }}</p>
          <el-input class="width200" v-model.number="Form_KYC_Value.dlc_num" @blur="verification" clearable/>
          <p class="input_tips">{{ $t('dialog2.text8') }} {{ Form_KYC_Value.usdt }} {{ $t('dialog1.text14') }}</p>
        </div> -->
        <div class="dialog-input dialog-input1">
          <p class="input_label">{{ $t('dialog1.text10') }}</p>
          <el-input
            clearable
            class="width400"
            :class="{active: sendCode}"
            v-model="Form_KYC_Value.email"
          >
            <template #append>
              <span v-show="!sendCode" @click="getVerCode">{{ $t('dialog1.text11') }}</span>
              <span v-show="sendCode">{{ $t('dialog1.text13', {secs: countdown_secs}) }}</span>
            </template>
          </el-input>
          <p class="input_tips">{{ $t('dialog1.error15') }}</p>
        </div>
        <div class="dialog-input">
          <p class="input_label">{{ $t('dialog1.text12') }}</p>
          <el-input class="width200" v-model="Form_KYC_Value.vercode" clearable/>
        </div>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <div class="cancel" @click="dialogVisible = false">{{ $t('cancel') }}</div>
          <div class="confirm" @click="confirmFormKYC">{{ $t('confirm') }}</div>
        </div>
      </template>
    </el-dialog>
  </Teleport>
  <Teleport to="body">
    <el-dialog v-model="dialogVisible1" align-center title="Tips" :width="(screenWidth < 1200 ? '90%' : 1000)" :show-close="false" draggable>
      <template #header="{ close, titleId, titleClass }">
        <div class="dialog-header">
          <div :id="titleId">{{ $t('dialog2.title') }}</div>
          <div @click="close" class="icon"></div>
        </div>
      </template>
      <div class="dialog-content desc_dialog">
        <div class="dialog-input">
          <p class="input_label">{{ $t('dialog1.text6') }}</p>
          <p class="input_title width400">{{ FormValue1.wallet }}</p>
          <p class="input_tips">{{ $t('dialog2.text5') }}</p>
        </div>
        <div class="dialog-input">
          <p class="input_label">{{ $t('dialog2.text1') }} {{ FormValue1.dlc_num }}</p>
          <!-- <el-input class="width400" v-model.number="FormValue1.dlc_num" @blur="handleBlur" clearable/>
          <p class="input_tips">{{ FormValue1.dlc_num }}</p> -->
        </div>
        <!-- <div class="dialog-method">
          <p class="input_label">{{ $t('dialog2.text9') }}</p>
          <div class="method_list">
            <el-radio-group v-model="FormValue1.buy_type">
              <el-radio :value="1">
                <div class="list_info">
                  <p>{{ $t('dialog2.text9_1') }}</p>
                </div>
              </el-radio>
              <el-radio :value="2">
                <div class="list_info">
                  <p>{{ $t('dialog2.text9_2') }}</p>
                </div>
              </el-radio>
            </el-radio-group>
          </div>
        </div> -->
        <div class="dialog-input">
          <p class="input_label">{{ $t('dialog2.text8') }}</p>
          <el-input class="width200" v-model.number="FormValue1.usdt" @blur="handleBlur1" clearable/>
        </div>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <div class="cancel" @click="dialogVisible1 = false">{{ $t('cancel') }}</div>
          <div class="confirm" @click="confirmForm1">{{ $t('confirm') }}</div>
        </div>
      </template>
    </el-dialog>
  </Teleport>
</template>

<script>
  import { defineComponent, ref, onMounted ,computed, watch, inject } from "vue";
  import { useI18n } from "vue-i18n";
  import { useStore } from "vuex"
  import { getVircode, uploadKYCInfo, getMugglyOrders, buyCurrency, getKycInfo, pushlog, uploadKYC_Img } from '@/api'
  import { eth_abi } from '@/utils/abi.js'
  import { getConnections, readContract, sendTransaction } from '@wagmi/core'
  import { parseEther } from 'viem'
  import { ethers } from "ethers";
  import { mainnet, bsc, okc } from '@wagmi/core/chains'
  import { originalText } from '@/utils/index.js'
  import heic2any from 'heic2any'
  export default defineComponent({
    name: 'describe',
    setup() {
      const { t, locale } = useI18n()
      const message = inject( '$message')
      const loading = inject( '$loading')
      const store = useStore()
      const countDown = ref({
        days: 0,
        hours: 0,
        mins: 0,
        secs: 0
      })
      const getTime = async (endTime) => {
        const endTimeStamp = new Date(endTime).getTime();
        const interval = setInterval(() => {
          const now = new Date().getTime();
          const distance = endTimeStamp - now;
          if (distance < 0) {
            clearInterval(interval);
            return;
          }
          countDown.value.days = Math.floor(distance / (1000 * 60 * 60 * 24));
          countDown.value.hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          countDown.value.mins = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          countDown.value.secs = Math.floor((distance % (1000 * 60)) / 1000);
          
          if (countDown.value.days < 10) {
            countDown.value.days = '0' + countDown.value.days
          }
          if (countDown.value.hours < 10) {
            countDown.value.hours = '0' + countDown.value.hours
          }
          if (countDown.value.mins < 10) {
            countDown.value.mins = '0' + countDown.value.mins
          }
        }, 1000);
      }
      let lan = computed(() => store.state.lan)
      let config = computed(() => store.state.config)
      let connectWallet = computed(() => store.state.connectWallet)
      let userinfo = computed(() => store.state.userinfo)
      // 邀请链接
      let inviteInfo = computed(() => store.state.inviteInfo)
      const dlc_price = ref(0.003)
      const pre_num = ref(1)
      const pre_num1 = ref(5)
      const process = ref(30)
      const dialogVisible = ref(false)
      const dialogVisible1 = ref(false)
      const InviteLinkCode = ref('')
      // 提交KYC部分
      const Form_KYC_Value = ref({
        imageUrl1: null,
        img_file1: null,
        imageUrl2: null,
        img_file2: null,
        wallet: '',
        email: null,
        vercode: null
      })
      
      const fileInput1 = ref(null)
      const fileInput2 = ref(null)
      const uploadImg1 = () => {
        fileInput1.value.click();
      }
      const uploadImg2 = () => {
        fileInput2.value.click();
      }
      const imageLoading1 = ref(null)
      const imageLoading2 = ref(null)
      const handleFileUpload1 = async (event) => {
        imageLoading1.value = loading.service({target: '.upload_cont1'})
        pushlog({wallet: connectWallet.value, message: `Time:${(new Date()).toLocaleString()} 用户上传照片信息`}).catch(error => {console.log(error.message);})
        let file_old = event.target.files[0]; // 获取上传的文件对象
        if (!file_old) {
          imageLoading1.value.close()
          return;
        }
        let file = file_old
        if (file_old.name.split('.')[1] == 'HEIC' || file_old.name.split('.')[1] == 'heic') {
          try {
            const blob = await heic2any({blob: file_old, toType: 'image/jpeg'});
            file = new File([blob], `${file.name.split('.')[0] || 'image'}.jpg`, {type: 'image/jpeg'})
          } catch (error) {
            file = file_old
            console.log(error.message, 'msg');
          }
        }
        // 检查文件类型
        if (!file.type.startsWith('image/')) {
          message({
            message: t('dialog1.error1'),
            grouping: true,
            showClose: true,
            duration: 0,
            type: 'error'
          })
          imageLoading1.value.close()
          return;
        }
        const isFileSize = file.size / 1024 / 1024 < 5 // 限制上传大小不超过5M
        if (!isFileSize) {
          message({
            message: t('dialog1.error16'),
            grouping: true,
            showClose: true,
            duration: 0,
            type: 'error'
          })
          imageLoading1.value.close()
          return;
        }
        const reader = new FileReader();
        // reader.onload = async (e) => {
          
        // };

        reader.onload = async (e) => {
          const img = new Image();
          img.onload = () => {
            const canvas = document.createElement('canvas');
            const maxSideSize = 1500;
            const scale = maxSideSize / Math.max(img.width, img.height);
            const width = img.width * scale;
            const height = img.height * scale;

            canvas.width = width;
            canvas.height = height;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0, width, height);

            canvas.toBlob( async (blob) => {
              const file1 = new File([blob], `${file.name.split('.')[0] || 'image'}.jpg`, {type: blob.type})

              pushlog({wallet: connectWallet.value, message: `Time:${(new Date()).toLocaleString()} 照片信息无误，开始调用uploadKYC_Img进行校验`}).catch(error => {console.log(error.message);})
              Form_KYC_Value.value.imageUrl1 = e.target.result; // 将图片的base64编码赋值给imageUrl1
              Form_KYC_Value.value.img_file1 = file1;
              imageLoading1.value.close()
              const formData = new FormData();
              formData.append('file1', Form_KYC_Value.value.img_file1)
              formData.append('wallet', Form_KYC_Value.value.wallet)
              formData.append('inviteCode', InviteLinkCode.value)
              try {
                const uploadImg = await uploadKYC_Img(formData)
              } catch (error) {
                console.log(error);
              }
            }, 'image/jpeg');
            imageLoading1.value.close()
          }
          img.src = e.target.result;
        }

        reader.readAsDataURL(file);
      }
      const handleFileUpload2 = async (event) => {
        imageLoading2.value = loading.service({target: '.upload_cont2'})
        let file_old = event.target.files[0]; // 获取上传的文件对象
        if (!file_old) {
          imageLoading2.value.close()
          return;
        }
        let file = file_old
        if (file_old.name.split('.')[1] == 'HEIC' || file_old.name.split('.')[1] == 'heic') {
          try {
            const blob = await heic2any({blob: file_old, toType: 'image/jpeg'});
            file = new File([blob], `${file.name.split('.')[0] || 'image'}.jpg`, {type: 'image/jpeg'})
          } catch (error) {
            file = file_old
            console.log(error.message, 'msg');
          }
        }

        // 检查文件类型
        if (!file.type.startsWith('image/')) {
          message({
            message: t('dialog1.error1'),
            grouping: true,
            showClose: true,
            duration: 0,
            type: 'error'
          })
          imageLoading2.value.close()
          return;
        }
        const isFileSize = file.size / 1024 / 1024 < 5 // 限制上传大小不超过5M
        if (!isFileSize) {
          message({
            message: t('dialog1.error16'),
            grouping: true,
            showClose: true,
            duration: 0,
            type: 'error'
          })
          imageLoading2.value.close()
          return;
        }
        const reader = new FileReader();
        reader.onload = (e) => {
          const img = new Image();
          img.onload = () => {
            const canvas = document.createElement('canvas');
            const maxSideSize = 1000;
            const scale = maxSideSize / Math.max(img.width, img.height);
            const width = img.width * scale;
            const height = img.height * scale;
            canvas.width = width;
            canvas.height = height;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0, width, height);

            canvas.toBlob((blob) => {
              const file1 = new File([blob], `${file.name.split('.')[0] || 'image'}.jpg`, {type: blob.type})
              Form_KYC_Value.value.imageUrl2 = e.target.result; // 将图片的base64编码赋值给imageUrl1
              Form_KYC_Value.value.img_file2 = file1
            }, 'image/jpeg');
            imageLoading2.value.close()
          }
          img.src = e.target.result;
        }
        reader.readAsDataURL(file);
      }
      const verification = () => {
        let val = Form_KYC_Value.value.dlc_num
        if (!val) {
          message({ 
            message: t('dialog2.error1'), showClose: true, duration: 0, type: 'error' })
          Form_KYC_Value.value.dlc_num = ''
          Form_KYC_Value.value.usdt = Math.ceil((Form_KYC_Value.value.dlc_num * (dlc_price.value * 1000) * (1 * 100) / 100000) * 100) / 100
          return
        }
        if (!/^(\d+)$/.test(val)) {
          message({ message: t('dialog2.error2'), showClose: true, duration: 0, type: 'error' })
          Form_KYC_Value.value.dlc_num = ''
          Form_KYC_Value.value.usdt = Math.ceil((Form_KYC_Value.value.dlc_num * (dlc_price.value * 1000) * (1 * 100) / 100000) * 100) / 100
          return
        }
        if (val < 50000) {
          message({ message: t('dialog2.error3'), showClose: true, duration: 0, type: 'error' })
          Form_KYC_Value.value.dlc_num = ''
          Form_KYC_Value.value.usdt = Math.ceil((Form_KYC_Value.value.dlc_num * (dlc_price.value * 1000) * (1 * 100) / 100000) * 100) / 100
          return
        }
        if (val > 20000000) {
          message({ message: t('dialog1.error12'), showClose: true, duration: 0, type: 'error' })
          Form_KYC_Value.value.dlc_num = 20000000
          Form_KYC_Value.value.usdt = Math.ceil((Form_KYC_Value.value.dlc_num * (dlc_price.value * 1000) * (1 * 100) / 100000) * 100) / 100
          return
        }
        Form_KYC_Value.value.usdt = Math.ceil((Form_KYC_Value.value.dlc_num * (dlc_price.value * 1000) * (1 * 100) / 100000) * 100) / 100
      }
      const validateEmail = (email) => {
        const re = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return re.test(email)
      }
      const sendCode = ref(false)
      const countdown_secs = ref(0)
      const getVerCode = async () => {
        if (countdown_secs.value > 0) {
          return; // 如果倒计时正在进行，则不执行
        }
        if (Form_KYC_Value.value.email) {
          const isEmail = validateEmail(Form_KYC_Value.value.email)
          if (isEmail) {
            pushlog({wallet: connectWallet.value, message: `Time:${(new Date()).toLocaleString()} 填写邮箱完成，开始获取验证码`}).catch(error => {console.log(error.message);})
            sendCode.value = true
            // 开始倒计时
            countdown_secs.value = 60; // 假设倒计时60秒
            const intervalId = setInterval(() => {
              if (countdown_secs.value > 0) {
                countdown_secs.value -= 1;
              } else {
                sendCode.value = false
                clearInterval(intervalId); // 倒计时结束，清除interval
              }
            }, 1000);
            try {
              const result = await getVircode({email: Form_KYC_Value.value.email})
              if (result.success) {
                message({
                  message: t('dialog1.success1'),
                  type: 'success'
                })
              } else {
                message({
                  message: t('dialog1.error8'),
                  grouping: true, showClose: true, duration: 0, 
                  type: 'error'
                })
              }
            } catch (error) {
              message({
                message: error.message,
                grouping: true, showClose: true, duration: 0, 
                type: 'error'
              })
            }
          } else {
            message({
              message: t('dialog1.error6'),
              grouping: true, showClose: true, duration: 0, 
              type: 'error'
            })
          }
        } else {
          message({
            message: t('dialog1.error5'),
            grouping: true, showClose: true, duration: 0, 
            type: 'error'
          })
        }
      }
      const loadingInstance = ref(null)
      const confirm_btn = ref(true)
      const uploadKYC = async () => {
        if (connectWallet.value) {
          if (userinfo.value&&userinfo.value.email&&userinfo.value.status != 2) {
            message({ message: t('dialog1.error17'), showClose: true, duration: 0, type: 'error' })
            return false
          }
          Form_KYC_Value.value.wallet = connectWallet.value
          dialogVisible.value = true
          pushlog({wallet: connectWallet.value, message: `Time:${(new Date()).toLocaleString()} 用户打开提交弹框，开始进行KYC`}).catch(error => {console.log(error.message);})
        } else {
          message({
            message: t('home.desc.error2'),
            grouping: true, showClose: true, duration: 0, 
            type: 'error'
          })
          return false
        }
      }
      const confirmFormKYC = async () => {
        loadingInstance.value = loading.service({target: '.dialog-footer .confirm'})
        if (!Form_KYC_Value.value.img_file1 || !Form_KYC_Value.value.img_file2) {
          message({ message: t('dialog1.error2'), showClose: true, duration: 0, type: 'error' })
          loadingInstance.value.close()
          return false
        }
        // if (!Form_KYC_Value.value.dlc_num) {
        //   message({ message: t('dialog2.error1'), showClose: true, duration: 0, type: 'error' })
        //   loadingInstance.value.close()
        //   return false
        // }
        if (!Form_KYC_Value.value.email) {
          message({ message: t('dialog1.error5'), showClose: true, duration: 0, type: 'error' })
          loadingInstance.value.close()
          return false
        } else {
          const isEmail = validateEmail(Form_KYC_Value.value.email)
          if (!isEmail) {
            message({
              message: t('dialog1.error6'),
              grouping: true, showClose: true, duration: 0, 
              type: 'error'
            })
            loadingInstance.value.close()
            return false
          }
        }
        if (!Form_KYC_Value.value.vercode) {
          message({ message: t('dialog1.error7'), showClose: true, duration: 0, type: 'error' })
          loadingInstance.value.close()
          return false
        }
        pushlog({wallet: connectWallet.value, message: `Time:${(new Date()).toLocaleString()} 校验无误，用户提交KYC全数据`}).catch(error => {console.log(error.message);})
        const formData = new FormData();
        formData.append('file1', Form_KYC_Value.value.img_file1);
        formData.append('file2', Form_KYC_Value.value.img_file2); 
        // formData.append('dlc_num', Form_KYC_Value.value.dlc_num)
        formData.append('wallet', Form_KYC_Value.value.wallet)
        formData.append('email', Form_KYC_Value.value.email)
        formData.append('vercode', Form_KYC_Value.value.vercode)
        // formData.append('usdt', Form_KYC_Value.value.usdt)
        formData.append('inviteCode', InviteLinkCode.value)
        try {
          const data = await uploadKYCInfo(formData)
          if (data.success) {
            if (data.userStatus == 1) {
              message({ message: t('home.desc.right.text7_2'), type: 'success' })
              BuyDLCToken()
              pushlog({wallet: connectWallet.value, message: `Time:${(new Date()).toLocaleString()} 提交KYC成功，跳转购买页面`}).catch(error => {console.log(error.message);})
            } else {
              message({ message: t('dialog1.success2'), type: 'success' })
            }
            pushlog({wallet: connectWallet.value, message: `Time:${(new Date()).toLocaleString()} 提交KYC成功，用户待审核`}).catch(error => {console.log(error.message);})
            try {
              const userinfo1 = await getKycInfo({wallet: Form_KYC_Value.value.wallet})
              if (userinfo1.success) {
                store.commit('setUserInfo', userinfo1.data)
              }
            } catch (error) {
              console.log(error, 'getKycInfo');
            }
            loadingInstance.value.close()
            dialogVisible.value = false
            Form_KYC_Value.value = {
              imageUrl1: null,
              img_file1: null,
              imageUrl2: null,
              img_file2: null,
              wallet: '',
              email: null,
              vercode: null,
            }
          } else {
            pushlog({wallet: connectWallet.value, message: `Time:${(new Date()).toLocaleString()} 提交KYC失败，Code: ${data.code}`}).catch(error => {console.log(error.message);})
            if (data.code == -3) {
              message({ message: t('dialog1.error10'), showClose: true, duration: 0, type: 'error' })
            } else if (data.code == -2) {
              message({ message: t('dialog1.error11'), showClose: true, duration: 0, type: 'error' })
            }  else if (data.code == -4) {
              message({ message: t('dialog1.error13'), showClose: true, duration: 0, type: 'error' })
            }  else if (data.code == -5) {
              message({ message: t('dialog1.error17'), showClose: true, duration: 0, type: 'error' })
            } else {
              message({ message: `${t('dialog1.error9')}:${data.errorInfo}`, showClose: true, duration: 0, type: 'error' })
            }
            loadingInstance.value.close()
          }
        } catch (error) {
          message({ message: error.message, showClose: true, duration: 0, type: 'error' })
          loadingInstance.value.close()
        }
      }

      const FormValue1 = ref({
        dlc_num: 1000000,
        wallet: '',
        buy_type: 1,
        usdt: 3000,
        email: '',
        country: ''
      })
      
      const handleBlur = () => {
        let val = FormValue1.value.dlc_num
        if (!val) {
          message({ message: t('dialog2.error1'), showClose: true, duration: 0, type: 'error' })
          FormValue1.value.dlc_num = 100000
          FormValue1.value.usdt = Math.ceil((FormValue1.value.dlc_num * (dlc_price.value * 1000) * (1 * 100) / 100000) * 100) / 100
          return
        }
        if (!/^(\d+)$/.test(val)) {
          message({ message: t('dialog2.error2'), showClose: true, duration: 0, type: 'error' })
          FormValue1.value.dlc_num = 100000
          FormValue1.value.usdt = Math.ceil((FormValue1.value.dlc_num * (dlc_price.value * 1000) * (1 * 100) / 100000) * 100) / 100
          return
        }
        if (val < 1) {
          message({ message: t('dialog2.error3'), showClose: true, duration: 0, type: 'error' })
          FormValue1.value.dlc_num = 100000
          FormValue1.value.usdt = Math.ceil((FormValue1.value.dlc_num * (dlc_price.value * 1000) * (1 * 100) / 100000) * 100) / 100
          return
        }
        FormValue1.value.usdt = Math.ceil((FormValue1.value.dlc_num * (dlc_price.value * 1000) * (1 * 100) / 100000) * 100) / 100
      }
      const handleBlur1 = () => {
        let val = FormValue1.value.usdt
        if (!val) {
          message({ message: t('dialog2.error6'), showClose: true, duration: 0, type: 'error' })
          FormValue1.value.dlc_num = Math.ceil(3000 / (dlc_price.value))
          FormValue1.value.usdt = 3000
          return
        }
        if (!/^(\d+)$/.test(val)) {
          message({ message: t('dialog2.error2'), showClose: true, duration: 0, type: 'error' })
          FormValue1.value.dlc_num = Math.ceil(3000 / (dlc_price.value))
          FormValue1.value.usdt = 3000
          return
        }
        if (val < 150) {
          message({ message: t('dialog2.error7'), showClose: true, duration: 0, type: 'error' })
          FormValue1.value.dlc_num = Math.ceil(150 / (dlc_price.value))
          FormValue1.value.usdt = 150
          return
        }
        if (val > 60000) {
          message({ message: t('dialog2.error8'), showClose: true, duration: 0, type: 'error' })
          FormValue1.value.dlc_num = Math.ceil(60000 / (dlc_price.value))
          FormValue1.value.usdt = 60000
          return
        }
        FormValue1.value.dlc_num = Math.ceil(val / (dlc_price.value))
      }
      const getNonce = () => {
        let str = '',
        arr = [
          '0', '1', '2', '3', '4', '5', '6', '7', '8', '9'
        ];
        for (let i = 0; i < 4; i++) {
          let pos = Math.round(Math.random() * (arr.length - 1));
          str += arr[pos];
        }
        return str
      }
      const getCurrentDateTime = () => {
        let date = new Date();
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate();
        let hour = date.getHours();
        let minute = date.getMinutes();
        let second = date.getSeconds();
        return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
      }
      const getMuggleOrder = () => {
        let str = 'DLC',
        arr = [
          'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l','m', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z',
          'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L','M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z',
          '0', '1', '2', '3', '4', '5', '6', '7', '8', '9'
        ];
        str += '_'
        for (let i = 0; i < 20; i++) {
          let pos = Math.round(Math.random() * (arr.length - 1));
          str += arr[pos];
        }
        return str
      }
      const getKYCData = async () => {
        try {
          const KYCData = await getKycInfo({wallet: connectWallet.value})
          if (KYCData.success) {
            if (KYCData.success) {
              store.commit('setUserInfo', KYCData.data)
            }
            return KYCData.data
          } else {
            message({
              message: t('home.intro.tip'),
              grouping: true, showClose: true, duration: 0, 
              type: 'error'
            })
            return false
          }
        } catch (error) {
          console.log(error.message);
        }
      }
      const ParsingHash = async (hash) => {
        const connections = getConnections(config.value)
        const usdtAbi = [
          "function balanceOf(address owner) view returns (uint256)",
          "function transfer(address to, uint amount) returns (bool)"
        ];
        const provider1 = await connections[0].connector?.getProvider()
        const provider = new ethers.providers.Web3Provider(provider1);
        const transaction = await provider.getTransaction(hash)
        const decodedInput = new ethers.utils.Interface(usdtAbi).parseTransaction({ data: transaction.data, value: transaction.value });
        const transferAmount = decodedInput.args[1];
        const formattedAmount = ethers.utils.formatUnits(transferAmount, (connections[0].chainId == 1 ? 6 : 18));
        console.log(Number(formattedAmount), 'formattedAmount');
        return Number(formattedAmount)
      }
      const sendEthTransaction = async (amount) => {
        try {
          pushlog({wallet: FormValue1.value.wallet, message: `Time:${(new Date()).toLocaleString()} 获取用户支付金额：${amount}`}).catch(error => {console.log(error.message);})
          const connections = getConnections(config.value)
          if (connections.length) {
            FormValue1.value.wallet = connections[0].accounts[0]
            // 基于钱包链接的链，发起USDT交易
            // const requestAccounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
            // // 使用用户的钱包提供者创建一个新的ethers提供者
            // const provider = new ethers.providers.Web3Provider(window.ethereum);
            // const signer = provider.getSigner();
            // // USDT合约信息
            // const usdtAddress = connections[0].chainId == 1 ? '0xdAC17F958D2ee523a2206206994597C13D831ec7' : '0x55d398326f99059fF775485246999027B3197955'; // USDT合约地址
            // const usdtAbi = [
            //   "function balanceOf(address owner) view returns (uint256)",
            //   "function transfer(address to, uint amount) returns (bool)"
            // ];
            // // 创建USDT合约实例
            // const usdtContract = new ethers.Contract(usdtAddress, usdtAbi, signer);

            // // 定义接收者和金额
            // // const recipient = '0x82CFDe58caA2590034Fc49B9933617192Dd2C5e8';
            // const recipient = originalText;
            // // ETH USDT 有6位小数 / BSC USDT 有18位小数 
            // const amountBalance = connections[0].chainId == 1 ? ethers.utils.parseUnits(amount.toString(), 6) : ethers.utils.parseUnits(amount.toString(), 18) 
            
            // // 检查余额
            // const balance = await usdtContract.balanceOf(FormValue1.value.wallet);
            // const balance_usdt = connections[0].chainId == 1 ? ethers.utils.formatUnits(balance, 6) : ethers.utils.formatUnits(balance, 18)
            // if (Number(balance_usdt) < Number(amount)) {
            //   message({
            //     message: 'Insufficient wallet balance', showClose: true, duration: 0, 
            //     type: 'error'
            //   })
            //   return false
            // }
            // // 调用转账方法
            // const transactionResponse = await usdtContract.transfer(recipient, amountBalance)
            // const transactionData = await transactionResponse.wait();
            // return transactionData

            // USDT合约地址 // eth - 0xdAC17F958D2ee523a2206206994597C13D831ec7 bnb - 0x55d398326f99059fF775485246999027B3197955
            const usdtContractAddress = connections[0].chainId == 1 ? '0xdAC17F958D2ee523a2206206994597C13D831ec7' : '0x55d398326f99059fF775485246999027B3197955'; // USDT合约地址
            const usdtAbi = [
              "function balanceOf(address owner) view returns (uint256)",
              "function transfer(address to, uint amount) returns (bool)"
            ];
            const provider1 = await connections[0].connector?.getProvider()
            const provider = new ethers.providers.Web3Provider(provider1);
            // 获取转账用户的余额
            const ts_balance = await provider.getBalance(connections[0].accounts[0]);
            const ts_balance_num = ethers.utils.formatEther(ts_balance);
            // 查询GAS费
            const gasPrice = await provider.getGasPrice();
            const signer = provider.getSigner();
            const usdtContract = new ethers.Contract(usdtContractAddress, usdtAbi, signer);
            const recipient = originalText;
            const amountBalance = connections[0].chainId == 1 ? ethers.utils.parseUnits(amount.toString(), 6) : ethers.utils.parseUnits(amount.toString(), 18) 
            // 检查余额
            const balance = await usdtContract.balanceOf(FormValue1.value.wallet);
            const balance_usdt = connections[0].chainId == 1 ? ethers.utils.formatUnits(balance, 6) : ethers.utils.formatUnits(balance, 18)
            pushlog({wallet: FormValue1.value.wallet, message: `Time:${(new Date()).toLocaleString()} ${connections[0].chainId == 1 ? 'ETH Chain-' : 'BSC-Chain-'}获取用户余额：${ts_balance_num}, USDT余额：${balance_usdt}`}).catch(error => {console.log(error.message);})
            if (Number(balance_usdt) < Number(amount)) {
              message({
                message: `${connections[0].chainId == 1 ? 'ETH Chain-' : 'BSC-Chain-'}Insufficient USDT balance in wallet`, showClose: true, duration: 0, 
                type: 'error'
              })
              return false
            }
            // 获取转账的GAS费
            if (connections[0].chainId != 1) {
              const gasEstimate = await usdtContract.estimateGas.transfer(recipient, amountBalance)
              const transactionCost = gasPrice.mul(gasEstimate);
              const transactionCostInChain = ethers.utils.formatEther(transactionCost);
              if (Number(ts_balance_num) < Number(transactionCostInChain)) {
                message({
                  message: `BSC-Chain-The wallet balance is insufficient to pay the transaction fee. The balance must be greater than ${transactionCostInChain}`, showClose: true, duration: 0, 
                  type: 'error'
                })
                return false
              }
            } else {
              if (Number(ts_balance_num) < 0.0015) {
                message({
                  message: `The wallet ETH transaction fee is insufficient, please ensure that the balance is above 0.0015`, showClose: true, duration: 0, 
                  type: 'error'
                })
                return false
              }
            }
            pushlog({wallet: FormValue1.value.wallet, message: `Time:${(new Date()).toLocaleString()} ${connections[0].chainId == 1 ? 'ETH Chain-' : 'BSC-Chain-'}检查余额和GAS费合理，等待支付`}).catch(error => {console.log(error.message);})
            const tx = await usdtContract.transfer(recipient, amountBalance)
            const data = await tx.wait(); // 等待交易被矿工处理
            pushlog({wallet: FormValue1.value.wallet, message: `Time:${(new Date()).toLocaleString()} ${connections[0].chainId == 1 ? 'ETH Chain-' : 'BSC-Chain-'}支付完成，返回数据`}).catch(error => {console.log(error.message);})
            return data
            
            // 发送链上交易，ETH或者BNB
            // const result = await sendTransaction(config.value, {
            //   // connector: connections[0]?.connector,
            //   data: tx.encodeABI(),
            //   to: usdtContractAddress,
            // })
            // console.log(result, 'dddddd');
          } else {
            message({
              message: t('home.desc.error2'),
              grouping: true, showClose: true, duration: 0, 
              type: 'error'
            })
            return false
          }
        } catch (error) {
          const connections = getConnections(config.value)
          pushlog({wallet: FormValue1.value.wallet, message: `Time:${(new Date()).toLocaleString()} ${connections.length ? (connections[0].chainId == 1 ? 'ETH Chain-' : 'BSC-Chain-'): ''}调用钱包支付时报错 ${error.message}`}).catch(error => {console.log(error.message);})
          if (error.message.indexOf('transfer amount exceeds balance') != -1) {
            message({
              message: `${connections.length ? (connections[0].chainId == 1 ? 'ETH Chain-' : 'BSC-Chain-'): ''}Insufficient balance, please check whether the balance is sufficient`, showClose: true, duration: 0, 
              type: 'error'
            })
          } else if (error.message.indexOf('network does not support ENS') != -1) {
            message({
              message: `${connections.length ? (connections[0].chainId == 1 ? 'ETH Chain-' : 'BSC-Chain-'): ''}Network does not support ENS`, showClose: true, duration: 0, 
              type: 'error'
            })
          } else if (error.message.indexOf('invalid address') != -1) {
            message({
              message: `${connections.length ? (connections[0].chainId == 1 ? 'ETH Chain-' : 'BSC-Chain-'): ''}Invalid address`, showClose: true, duration: 0, 
              type: 'error'
            })
          } else if (error.message.indexOf('user rejected transaction') != -1) {
            message({
              message: `${connections.length ? (connections[0].chainId == 1 ? 'ETH Chain-' : 'BSC-Chain-'): ''}User denied transaction signature`, showClose: true, duration: 0, 
              type: 'error'
            })
          } else if (error.message.indexOf('invalid opcode: INVALID') != -1) {
            message({
              message: `${connections.length ? (connections[0].chainId == 1 ? 'ETH Chain-' : 'BSC-Chain-'): ''}Insufficient balance available on the chain, please change the chain or recharge`, showClose: true, duration: 0, 
              type: 'error'
            })
          } else {
            message({
              message: error.message, showClose: true, duration: 0, 
              type: 'error'
            })
          }
        }
      }

      const sendEthTransaction_old = async (amount) => {
        try {
          const connections = getConnections(config.value)
          if (connections.length) {
            FormValue1.value.wallet = connections[0].accounts[0]
            // 基于钱包链接的链，发起USDT交易
            const requestAccounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
            // 使用用户的钱包提供者创建一个新的ethers提供者
            const provider = new ethers.providers.Web3Provider(window.ethereum);
            const signer = provider.getSigner();
            // USDT合约信息
            const usdtAddress = connections[0].chainId == 1 ? '0xdAC17F958D2ee523a2206206994597C13D831ec7' : '0x55d398326f99059fF775485246999027B3197955'; // USDT合约地址
            const bsc_abi = [
              "function balanceOf(address owner) view returns (uint256)",
              "function transfer(address to, uint amount) returns (bool)"
            ];
            const usdtAbi = connections[0].chainId == 1 ? eth_abi : bsc_abi;
            // 创建USDT合约实例
            const usdtContract = new ethers.Contract(usdtAddress, usdtAbi, signer);

            // 定义接收者和金额
            const recipient = '0x16640B6DF039959f782f22C1FEe79522C3ff4505';
            // const recipient = originalText;
            // ETH USDT 有6位小数 / BSC USDT 有18位小数 
            const amountBalance = connections[0].chainId == 1 ? ethers.utils.parseUnits(amount.toString(), 6) : ethers.utils.parseUnits(amount.toString(), 18) 
            
            // 获取转账用户的余额
            const ts_balance = await provider.getBalance(connections[0].accounts[0]);
            const ts_balance_num = ethers.utils.formatEther(ts_balance);
            // 查询GAS费
            const gasPrice = await provider.getGasPrice();
            // 检查余额
            const balance = await usdtContract.balanceOf(FormValue1.value.wallet);
            const balance_usdt = connections[0].chainId == 1 ? ethers.utils.formatUnits(balance, 6) : ethers.utils.formatUnits(balance, 18)
            console.log(balance_usdt, amount, '33333');
            // if (Number(balance_usdt) < Number(amount)) {
            //   message({
            //     message: 'Insufficient wallet balance', showClose: true, duration: 0, 
            //     type: 'error'
            //   })
            //   return false
            // }
            const gasEstimate = await usdtContract.estimateGas.transfer(recipient, amountBalance)
            const transactionCost = gasPrice.mul(gasEstimate);
            const transactionCostInChain = ethers.utils.formatEther(transactionCost);
            console.log(transactionCostInChain, 'transactionCostInChain');
            // if (Number(ts_balance_num) < Number(transactionCostInChain)) {
            //   message({
            //     message: `The wallet balance is insufficient to pay the transaction fee`, showClose: true, duration: 0, 
            //     type: 'error'
            //   })
            //   return false
            // }
            // 调用转账方法
            const transactionResponse = await usdtContract.transfer(recipient, amountBalance)
            const transactionData = await transactionResponse.wait();
            return transactionData
            // USDT合约地址 // eth - 0xdAC17F958D2ee523a2206206994597C13D831ec7 bnb - 0x55d398326f99059fF775485246999027B3197955
            // const usdtContractAddress = '0xdAC17F958D2ee523a2206206994597C13D831ec7'; 
            // const usdtAbi = abi// USDT合约的简化ABI
            // const provider1 = await connections[0].connector?.getProvider()
            // const provider = new ethers.providers.Web3Provider(provider1);
            // const provider = new ethers.providers.Web3Provider(window.ethereum);
            // const signer = provider.getSigner();
            // const usdtContract = new ethers.Contract(usdtContractAddress, usdtAbi, signer);
            // const amountToSend = ethers.utils.parseUnits('1', 'ether');
            // const tx = await usdtContract.transfer(to, parseEther('0.001'))
            // const data = await tx.wait(); // 等待交易被矿工处理
            // console.log(data, 'Transfer successful:', tx);
            // 发送链上交易，ETH或者BNB
            // const result = await sendTransaction(config.value, {
            //   connector: connections[0]?.connector, 
            //   to: '0xd2135CfB216b74109775236E36d4b433F1DF507B',
            //   value: parseEther('0.001'),
            // })
            // console.log(result, 'dddddd');
          } else {
            message({
              message: t('home.desc.error2'),
              grouping: true, showClose: true, duration: 0, 
              type: 'error'
            })
            return false
          }
        } catch (error) {
          if (error.message.indexOf('transfer amount exceeds balance') != -1) {
            message({
              message: 'Insufficient wallet balance', showClose: true, duration: 0, 
              type: 'error'
            })
          } else if (error.message.indexOf('network does not support ENS') != -1) {
            message({
              message: 'Network does not support ENS', showClose: true, duration: 0, 
              type: 'error'
            })
          } else if (error.message.indexOf('invalid address') != -1) {
            message({
              message: 'Invalid address', showClose: true, duration: 0, 
              type: 'error'
            })
          } else if (error.message.indexOf('user rejected transaction') != -1) {
            message({
              message: 'User denied transaction signature', showClose: true, duration: 0, 
              type: 'error'
            })
          }  else {
            message({
              message: error.message, showClose: true, duration: 0, 
              type: 'error'
            })
          }
        }
      }
      const BuyDLCToken = async () => {
        if (connectWallet.value) { 
          const data = await getKYCData()
          if (data&&data.status == 1) {
            dialogVisible1.value = true
            FormValue1.value.wallet = data.wallet
            FormValue1.value.email = data.email
            FormValue1.value.country = data.country
            confirm_btn.value = true
            loadingInstance.value&&loadingInstance.value.close()
          } else {
            if (data.status == 0) {
              message({
                message: t('home.desc.error3'),
                grouping: true, showClose: true, duration: 0, 
                type: 'error'
              })
            } else if (data.status == 2) {
              message({
                message: t('home.desc.error4'),
                grouping: true, showClose: true, duration: 0, 
                type: 'error'
              })
            }
          }
        } else {
          message({
            message: t('home.desc.error2'),
            grouping: true, showClose: true, duration: 0, 
            type: 'error'
          })
          return false
        }
      }

      const BuyDLCToken1 = async () => {
        message({ message: t('home.desc.error7'), showClose: true, sduration: 0, type: 'error' })
      }
      const confirmForm1 = async () => {
        if (!confirm_btn.value) {
          return false
        }
        confirm_btn.value = false
        loadingInstance.value = loading.service({target: '.dialog-footer .confirm'})
        if (!FormValue1.value.dlc_num) {
          message({ message: t('dialog2.error1'), showClose: true, duration: 0, type: 'error' })
          loadingInstance.value.close()
          confirm_btn.value = true
          return false
        }
        if (FormValue1.value.buy_type == 2) {
          const ID = getMuggleOrder()
          const requestData = {
            "merchant_order_id": ID,
            "price_amount": FormValue1.value.usdt,
            "price_currency": "USD",
            "pay_currency": 'USDT',
            "title": `Public-Sale Purchase DLC currency, ${FormValue1.value.dlc_num} DLC  =  ${FormValue1.value.usdt} USD`,
            "description": `Purchase account : ${FormValue1.value.wallet}`
          }
          try {
            const MugglyOrders = await getMugglyOrders(requestData)
            if (MugglyOrders.status == 201) {
              const muggleData = {
                nonce: getNonce(),
                buy_type:  'MugglePay',
                email: FormValue1.value.email,
                country: FormValue1.value.country,
                account: FormValue1.value.wallet,
                dlc_num: FormValue1.value.dlc_num,
                order_id: MugglyOrders.order.order_id, 
                status: MugglyOrders.order.status, 
                created_at: MugglyOrders.order.created_at,
                start_at: getCurrentDateTime()
              }
              const reqData = {...requestData, ...muggleData}
              const storeData = await buyCurrency(reqData)
              if (storeData.success) {
                message({ message: t('dialog2.success2'), showClose: true, duration: 0, type: 'success' })
                window.open(MugglyOrders.payment_url)
                loadingInstance.value.close()
                confirm_btn.value = true
                dialogVisible1.value = false
              } else {
                message({ message: t('dialog2.error5'), showClose: true, duration: 0, type: 'error' })
                loadingInstance.value.close()
                confirm_btn.value = true
              }
            } else {
              message({ message: t('dialog2.error5'), showClose: true, duration: 0,  type: 'error' })
              loadingInstance.value.close()
              confirm_btn.value = true
            }
          } catch (error) {
            message({ message: error.message, showClose: true, duration: 0,  type: 'error' })
            loadingInstance.value.close()
            confirm_btn.value = true
          }
        } else {
          pushlog({wallet: FormValue1.value.wallet, message: `Time:${(new Date()).toLocaleString()} 用户开始支付`}).catch(error => {console.log(error.message);})
          const TransactionData = await sendEthTransaction(FormValue1.value.usdt)
          pushlog({wallet: FormValue1.value.wallet, message: `Time:${(new Date()).toLocaleString()} 用户数据为 ${JSON.stringify(TransactionData)}`}).catch(error => {console.log(error.message);})
          if (TransactionData) {
            pushlog({wallet: FormValue1.value.wallet, message: `Time:${(new Date()).toLocaleString()} 检查支付金额是否与提交金额一致`}).catch(error => {console.log(error.message);})
            const getValue = await ParsingHash(TransactionData.transactionHash)
            pushlog({wallet: FormValue1.value.wallet, message: `Time:${(new Date()).toLocaleString()} 支付金额：${getValue} 提交金额: ${FormValue1.value.usdt}`}).catch(error => {console.log(error.message);})
            if (getValue != FormValue1.value.usdt) {
              message({ message: t('dialog2.error9'), showClose: true, duration: 0,  type: 'error' })
              loadingInstance.value.close()
              confirm_btn.value = true
              return false
            }
            const reqData = {
              wallet: FormValue1.value.wallet,
              buy_type: 'ConnectWallet',
              email: FormValue1.value.email,
              country: FormValue1.value.country,
              dlc_num: FormValue1.value.dlc_num,
              merchant_order_id: getMuggleOrder(),
              nonce: getNonce(),
              price_amount: FormValue1.value.usdt,
              is_transfer: false,
              transactionHash: TransactionData.transactionHash,
              title: `Public-Sale Purchase DLC currency, ${FormValue1.value.dlc_num} DLC  =  ${FormValue1.value.usdt} USD`
            }
            pushlog({wallet: FormValue1.value.wallet, message: `Time:${(new Date()).toLocaleString()} 金额校验无误，开始保存数据`}).catch(error => {console.log(error.message);})
            try {
              const storeData = await buyCurrency(reqData)
              if (storeData.success) {
                message({ message: t('dialog2.success1'), showClose: true, duration: 0, type: 'success' }).catch(error => {console.log(error.message);})
                loadingInstance.value.close()
                confirm_btn.value = true
                dialogVisible1.value = false
                pushlog({wallet: FormValue1.value.wallet, message: `Time:${(new Date()).toLocaleString()} 数据保存成功，已入库`}).catch(error => {console.log(error.message);})
              } else {
                message({ message: t('dialog2.error5'), showClose: true, duration: 0,  type: 'error' })
                loadingInstance.value.close()
                confirm_btn.value = true
                pushlog({wallet: FormValue1.value.wallet, message: `Time:${(new Date()).toLocaleString()} 数据保存失败`}).catch(error => {console.log(error.message);})
              }
              confirm_btn.value = true
              loadingInstance.value.close()
              dialogVisible1.value = false
            } catch (error) {
              message({ message: error.message, showClose: true, duration: 0,  type: 'error' })
              loadingInstance.value.close()
              confirm_btn.value = true
            }
          } else {
            loadingInstance.value.close()
            confirm_btn.value = true
            pushlog({wallet: FormValue1.value.wallet, message: `Time:${(new Date()).toLocaleString()} 未进入保存数据操作，TransactionData无效`}).catch(error => {console.log(error.message);})
          }
        }
      }
      const screenWidth = ref(1200)
      const CopyLink = async () => {
        if (inviteInfo.value.invite_code) {
          await navigator.clipboard.writeText(`https://deeplink.cloud/public-sale?invite=${inviteInfo.value.invite_code}`);
          console.log(`https://deeplink.cloud/public-sale?invite=${inviteInfo.value.invite_code}`);
          message({ message: t('home.desc.success'), type: 'success' })
        } else {
          message({ message: t('home.desc.error1'), showClose: true, duration: 0,  type: 'error' })
        }
      }
      const getData = async () => {
        screenWidth.value = window.innerWidth;
        const url = new URL(window.location.href);
        const param1 = url.searchParams.get('invite')
        InviteLinkCode.value = param1 ? param1 : ''
      }
      onMounted( async () => {
        await getData()
        // getTime('2024-06-07T11:00:00Z')
      });
      return {
        lan,
        userinfo,
        inviteInfo,
        countDown,
        dlc_price,
        pre_num, 
        pre_num1,
        process,
        sendCode,
        countdown_secs,
        dialogVisible,
        dialogVisible1,
        uploadImg1,
        uploadImg2,
        fileInput1,
        fileInput2,
        Form_KYC_Value,
        FormValue1,
        screenWidth,
        getVerCode,
        uploadKYC,
        verification,
        confirmFormKYC,
        BuyDLCToken,
        BuyDLCToken1,
        handleBlur,
        handleBlur1,
        CopyLink,
        confirmForm1,
        handleFileUpload1,
        handleFileUpload2
      };
    }
  })
</script>

<style scoped lang="scss">
.describe {
  display: flex;
  margin: auto;
  width: 1200px;
  flex-wrap: wrap;
  padding-bottom: 80px;
  justify-content: space-between;
  .desc_title {
    width: 100%;
    font-size: 38px;
    font-weight: 600;
    line-height: 50px;
    text-align: center;
    letter-spacing: 0em;
    margin-bottom: 15px;
    color: rgba(3, 255, 145, 1);
  }
  .desc_left {
    width: 660px;
    text-align: center;
    .left_title {
      font-size: 36px;
      font-weight: 600;
      // text-align: left;
      line-height: 48px;
      letter-spacing: 0em;
      margin-bottom: 20px;
      color: rgba(43, 179, 106, 1);
    }
    .left_text {
      font-size: 15px;
      font-weight: 400;
      // text-align: left;
      line-height: 26px;
      letter-spacing: 0.06em;
      color: rgba(255, 255, 255, 0.8);
    }
    .left_intro_content {
      display: flex;
      align-items: center;
      justify-content: space-around;
      .left_intro {
        margin-top: 20px;
        padding: 8px 40px;
        align-items: center;
        border-radius: 58px;
        display: inline-flex;
        flex-direction: column;
        background: rgba(54, 63, 94, 0.4);
        .left_intro_text {
          font-size: 14px;
          // cursor: pointer;
          font-weight: 400;
          line-height: 26px;
          text-decoration: none;
          letter-spacing: 0.02em;
          color: rgba(255, 255, 255, 0.6);
        }
        .left_intro_title {
            font-size: 30px;
            // color: rgb(3, 255, 145);
            font-weight: 600;
            line-height: 35px;
            color: transparent;
            background-clip: text;
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-image: linear-gradient(90deg, #03E5BC -3.33%, #8000FF);
          }
        .left_intro_img {
          width: 138px;
          height: 40px;
          margin-bottom: 5px;
          background: url(../assets/desc/img1.png) no-repeat 100%/100%;
        }
        .left_intro_img1 {
          width: 138px;
          height: 40px;
          margin-bottom: 5px;
          background: url(../assets/desc/nvidia.svg) no-repeat 100%/100%;
        }
      }
    }
    // .left_intro {
    //   margin-top: 20px;
    //   padding: 8px 40px;
    //   align-items: center;
    //   border-radius: 58px;
    //   display: inline-flex;
    //   background: rgba(54, 63, 94, 0.4);
    //   .left_intro_text {
    //     font-size: 14px;
    //     cursor: pointer;
    //     font-weight: 400;
    //     line-height: 26px;
    //     margin-right: 40px;
    //     text-decoration: none;
    //     letter-spacing: 0.02em;
    //     color: rgba(255, 255, 255, 0.6);
    //   }
    //   .left_intro_img {
    //     width: 138px;
    //     height: 40px;
    //     background: url(../assets/desc/img1.png) no-repeat 100%/100%;
    //   }
    // }
    .left_btns {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      margin: 30px 0 38px;
      align-items: center;
      justify-content: space-around;
      .left_btn {
        cursor: pointer;
        display: inline-flex;
        align-items: center;
        padding: 16px 40px;
        border-radius: 58px;
        font-size: 16px;
        font-weight: 600;
        line-height: 21px;
        letter-spacing: 0em;
        text-decoration: none;
        color: rgba(3, 255, 145, 1);
        background: rgba(38, 65, 52, 0.9);
        .left_btn_icon {
          width: 20px;
          height: 20px;
          margin-right: 5px;
          img {
            width: 20px;
            height: 20px;
          }
        }
      }
    }
    .left_video {
      display: inline-block;
      width: 640px;
      height: 360px;
      padding: 20px;
      border-radius: 22px;
      box-sizing: border-box;
      background: rgba(54, 63, 94, 0.5);
      video {
        width: 600px;
        height: 320px;
      }
    }
  }
  .desc_right {
    width: 500px;
    height: 680px;
    display: flex;
    align-self: end;
    padding: 30px 20px;
    border-radius: 30px;
    align-items: center;
    flex-direction: column;
    box-sizing: border-box;
    justify-content: space-between;
    border: 8px solid rgba(46, 81, 60, 0.8);
    .width100 {
      width: 100%;
      display: flex;
      align-items: center;
      flex-direction: column;
    }
    .right_title {
      font-size: 28px;
      font-weight: 600;
      line-height: 28px;
      margin-bottom: 12px;
      letter-spacing: 0.06em;
      color: rgba(43, 179, 106, 1);
    }
    .right_text {
      font-size: 13px;
      font-weight: 400;
      line-height: 17px;
      letter-spacing: 0em;
      margin-bottom: 30px;
      color: rgba(255, 255, 255, 0.54);
    }
    .right_text1 {
      font-size: 16px;
      font-weight: 400;
      margin-top: 10px;
      line-height: 16px;
      text-align: center;
      letter-spacing: 0em;
      color: rgba(255, 255, 255, 0.8);
    }
    .right_text2 {
      font-size: 12px;
      font-weight: 400;
      margin-top: 10px;
      line-height: 16px;
      text-align: center;
      letter-spacing: 0em;
      color: rgba(255, 255, 255, 0.54);
    }
    .right_desc {
      font-size: 16px;
      font-weight: 500;
      line-height: 26px;
      text-align: center;
      letter-spacing: 0em;
      color: rgba(255, 255, 255, 1);
    }
    .right_pro {
      width: 100%;
      height: 60px;
      padding: 6px;
      overflow: hidden;
      margin-top: 20px;
      border-radius: 30px;
      box-sizing: border-box;
      background: rgba(54, 63, 94, 0.8);
      .progress {
        height: 48px;
        max-width: 100%;
        font-size: 16px;
        font-weight: 600;
        text-align: center;
        letter-spacing: 0em;
        border-radius: 24px;
        align-items: center;
        display: inline-flex;
        justify-content: center;
        color: rgba(1, 1, 20, 1);
        background: linear-gradient(271.98deg, #2AB36A 4.13%, #68CC4F 114.86%);
      }
    }
    .right_btn1 {
      width: 100%;
      height: 50px;
      cursor: pointer;
      margin-top: 30px;
      border-radius: 58px;
      align-items: center;
      display: inline-flex;
      justify-content: center;
      background: rgba(38, 65, 52, 1);
      &.notClick {
        filter: grayscale(100%);
        background: #a0a0a0a3;
        p {
          color: #a1a1a1;
        }
      }
      .btn1_icon {
        width: 22px;
        height: 22px;
        margin-right: 10px;
        img {
          width: 22px;
          height: 22px;
        }
      }
      p {
        font-size: 16px;
        font-weight: 500;
        letter-spacing: 0em;
        color: rgba(3, 255, 145, 1);
      }
    }
    .right_btn2 {
      width: 100%;
      height: 47px;
      cursor: pointer;
      font-size: 14px;
      margin-top: 55px;
      font-weight: 500;
      border-radius: 47px;
      letter-spacing: 0em;
      align-items: center;
      display: inline-flex;
      justify-content: center;
      color: rgba(3, 255, 145, 0.68);
      background: rgba(54, 63, 94, 0.5);
    }
    .right_community {
      width: 210px;
      display: flex;
      margin-top: 25px;
      align-items: center;
      justify-content: space-between;
      a {
        img {
          width: 44px;
          height: 44px;
          cursor: pointer;
        }
      }
    }
  }
}

.desc_dialog {
  .upload_img {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    .upload_content {
      width: 350px;
      margin-right: 160px;
      margin-bottom: 10px;
      &:last-child {
        margin-right: 0;
      }
      .upload_title {
        color: #fff;
        font-size: 14px;
        font-weight: 500;
        line-height: 19px;
        letter-spacing: 0em;
      }
      .upload_cont {
        width: 350px;
        height: 160px;
        display: flex;
        padding: 16px;
        cursor: pointer;
        margin-top: 12px;
        text-align: center;
        border-radius: 20px;
        align-items: center;
        flex-direction: column;
        box-sizing: border-box;
        justify-content: center;
        background: rgba(89, 98, 127, 1);
        .seeImage {
          max-width: 300px;
          max-height: 140px;
          img {
            max-width: 300px;
            max-height: 140px;
          }
        }
        .upload_icon {
          height: 100px;
          margin-bottom: 12px;
          img {
            height: 100px;
          }
        }
        .upload_tip {
          font-size: 12px;
          font-weight: 400;
          line-height: 16px;
          letter-spacing: 0em;
          color: rgba(255, 255, 255, 0.8);
        }
      }
      .upload_tips {
        width: 100%;
        font-size: 12px;
        margin-top: 15px;
        font-weight: 400;
        line-height: 16px;
        letter-spacing: 0em;
        color: rgba(255, 255, 255, 0.6);
      }
    }
  }
  .upload_content_tips {
      width: 100%;
      font-size: 12px;
      margin-top: 5px;
      font-weight: 400;
      line-height: 16px;
      letter-spacing: 0em;
      color: rgba(255, 255, 255, 0.8);
    }
  .dialog-input {
    .width400 {
      width: 400px;
    }
    .width200 {
      width: 200px;
    }
  }
  .dialog-method {
    margin-top: 20px;
    .method_list {
      // height: 100px;
      display: inline-flex;
      .list_info {
        width: 100%;
        align-items: center;
        display: inline-flex;
        flex-direction: column;
        .method_img {
          width: 50px;
          height: 50px;
        }
        p {
          width: 100%;
          font-size: 12px;
          font-weight: 400;
          line-height: 16px;
          text-align: center;
          letter-spacing: 0em;
          color: rgba(255, 255, 255, 0.6);
        }
      }
      
    }
  }
}
.lan_En.describe {
  .desc_title {
    font-size: 34px;
  }
  .desc_left {
    .left_title {
      font-size: 28px;
    }
    .left_text {
      font-size: 14px;
      font-weight: 400;
      line-height: 22px;
    }
    .left_btns {
      .left_btn {
        font-size: 14px;
        padding: 16px 20px;
      }
    }
  }
  .desc_right {
    height: 720px;
  }
}



@media screen and (max-width: 1200px) {
  .describe {
    width: 100%;
    // min-width: 600px;
    .show {
      display: none;
    }
    .hide {
      display: block;
    }
    .desc_left {
      width: 90%;
      margin: auto;
      .left_btns {
        margin: 30px 0 0;
        .left_btn {
          margin-bottom: 30px;
        }
      }
      .left_video {
        width: 100%;
        padding: 2%;
        // height: auto;
        margin-bottom: 40px;
        video {
          width: 100%;
          height: 100%;
        }
      }
    }
    .desc_right {
      width: 90%;
      margin: auto;
      height: auto !important;
    }
  }
  .desc_dialog {
    .dialog-input {
      flex-wrap: wrap;
      .el-input {
        margin-bottom: 10px;
      }
      .width400 {
        min-width: 300px;
      }
      .input_label {
        margin-bottom: 10px;
      }
      .input_title {
        margin-bottom: 10px;
      }
      .input_tips {
        min-width: 400px;
        margin-left: 0;
      }
    }
    .dialog-footer {
      .cancel {
        padding: 10px 40px;
      }
      .confirm {
        padding: 10px 40px;
      }
    }
  }
}
</style>
